// UI string translations (DE/EN/FR/IT/ES) and the `t()` lookup helper used
// throughout the legacy inline script via `data-i18n` attributes and direct calls.

const I18N: Record<string, Record<string, string>> = {
  de: {
    avatar_select: 'Avatar auswählen', avatar_change: 'Avatar ändern', name_placeholder: 'Dein Name',
    btn_online: 'ONLINE', btn_online_sub: 'Lobby erstellen oder beitreten',
    btn_local: 'LOKAL', btn_local_sub: 'ein Gerät wird herumgereicht',
    btn_wordpacks: 'WORD PACKS',
    wordpacks_heading: 'WORD PACKS',
    wordpacks_subtitle: 'Entdecke die Begriffe und ihre Motive. Öffne ein Pack, um alle Karten anzusehen.',
    wordpack_active: 'AKTIV',
    wordpack_categories: 'Kategorien',
    wordpack_words: 'Begriffe',
    wordpack_coming: 'MEHR PACKS BALD',
    wordpack_future_hint: 'Neue Packs können später eigene Kategorien, Covers und Regeln für die Auswahl mitbringen.',
    wordpack_empty: 'Noch keine Word Packs verfügbar.',
    lobby_heading: 'LOBBY', btn_create: 'Spiel erstellen', join_label: 'Code eingeben',
    btn_join: 'Beitreten', code_label: 'Spielcode', copied: 'Kopiert!', qr_scan_hint: 'SCANNEN ZUM BEITRETEN',
    rounds_label: 'Runden', rounds_n: '{n} Runden', time_label: 'Rundenzeit', time_infinite: '∞', time_min: '{n} Min', categories_label: 'Kategorien',
    custom_words_label: 'Eigene Wörter', custom_word_placeholder: 'Wort eingeben oder Liste einfügen...', custom_words_count: '{n} Wörter',
    btn_start_round: 'Runde starten',    btn_kill_lobby: 'Lobby auflösen', player_count: '{n} Spieler',
    no_lobbies: 'Gerade sind keine Lobbys online.', open_games: 'Offene Spiele',
    create_lobby_heading: 'LOBBY ERSTELLEN', create_access_title: 'LOBBY-ZUGANG', access_public: 'Offen', access_password: 'Mit Passwort',
    access_public_hint: 'Jeder kann direkt beitreten.', access_password_hint: 'Die Lobby bleibt sichtbar, zum Beitreten ist das Passwort nötig.',
    password_placeholder: 'Passwort (mind. 4 Zeichen)', password_optional: 'Passwort, falls erforderlich', password_new_placeholder: 'Neues Passwort', password_hint: 'Mindestens 4 Zeichen.',
    lobby_browser_title: 'ONLINE-LOBBYS', lobby_access_label: 'ZUGANG', load_more: 'Mehr Lobbys laden',
    lobby_status_lobby: 'Wartet in der Lobby', lobby_status_playing: 'Runde läuft', lobby_status_voting: 'Abstimmung', lobby_status_imposter_guess: 'Wort wird geraten', lobby_status_reveal: 'Ergebnis',
    lobby_join_public: 'Direkt beitreten', lobby_join_password: 'Mit Passwort beitreten', lobby_full: 'Voll', lobby_count: '{n} Lobbys online',
    lobby_info: '{n}/10 Spieler · {r} Runden', back_to_lobby: 'Zurück zur Lobby',
    local_heading: 'LOKAL', add_players: 'Spieler hinzufügen (2-6)',
    btn_start_game: 'Spiel starten',
    round_label: 'Runde', card_tap: 'Tippe zum Aufdecken',
    bottom_title: 'EINER LÜGT',
    bottom_hint: 'Beschreibt euer Wort vage — IMPOSTER muss bluffen.',
    bottom_hint_local: 'Beschreibt das Wort vage — IMPOSTER muss bluffen!',
    btn_start_vote: 'ABSTIMMUNG STARTEN', your_card: 'Deine Karte',
    you_are: 'Du bist', the_odd_one: 'IMPOSTER', hint_prefix: 'Hinweis:',
    pass_hint: 'Tippe die Karte zum Umdrehen', btn_next: 'Weiter',
    vote_heading: 'ABSTIMMUNG', vote_sub: 'Wer blufft?',
    btn_vote_ready: 'BEREIT', btn_vote: 'Stimme abgeben', waiting_votes: 'Warte auf alle Stimmen...',
    local_vote_hint: 'Tippe um abzustimmen', btn_vote_short: 'Abstimmen',
    ig_heading: 'ERWISCHT!', ig_sub: 'IMPOSTER wurde enttarnt!',
    ig_last_chance: 'Letzte Chance: Was war das Wort?', ig_category: 'Kategorie:',
    ig_placeholder: 'Dein Tipp...', btn_guess: 'Raten',
    ig_waiting: 'IMPOSTER rät...', ig_loading: 'Ergebnis wird geladen...',
    result_heading: 'ERGEBNIS', word_was: 'Das Wort war',
    was_odd_one: '{name} war IMPOSTER',
    badge_caught: 'ERWISCHT!', badge_escaped: 'ENTKOMMEN!',
    guess_prefix: 'Tipp:', guess_correct: 'Richtig! (+10)', guess_wrong: 'Falsch!',
    votes_label: 'Stimmen', scores_label: 'Punktestand',
    result_ready: 'BEREIT FÜR DIE NÄCHSTE RUNDE', result_ready_waiting: 'Warte auf alle · {count}/{total} bereit',
    btn_next_round: 'Nächste Runde', btn_show_final: 'Endstand anzeigen', btn_continue: 'Weiter', loading_next_round: 'Nächste Runde wird geladen...',
    final_heading: 'SPIELENDE', btn_new_game: 'Neues Spiel',
    avatar_preview: 'Dein GIF-Avatar', btn_random_avatar: 'Zufällig', btn_save: 'Speichern',
    giphy_search_placeholder: 'Memes, GIFs, Reactions suchen...', giphy_search_btn: 'Suchen', giphy_trending: 'Trending GIFs',
    giphy_results_for: 'Ergebnisse für "{q}"', giphy_empty: 'Keine GIFs gefunden. Versuch ein anderes Meme.',
    giphy_key_missing: 'GIPHY ist noch nicht konfiguriert. Setze WA_GIPHY_API_KEY auf dem Server oder lokal localStorage.wa_giphy_api_key.',
    giphy_key_status: 'GIPHY-Key fehlt', loading: 'Lädt...',
    cat_all_selected: 'Alle Kategorien', cat_n_selected: '{n} von {total} Kategorien', cat_select_all: 'Alle auswählen', cat_deselect_all: 'Alle abwählen', btn_done: 'Fertig',
    p_online: '{name} ist online', p_offline: '{name} ist offline',
    lobby_dissolved: 'Lobby wurde aufgelöst', game_cancelled: 'Spiel wurde abgebrochen',
    error_title: 'Fehler', error_join: 'Konnte nicht beitreten', error_start: 'Konnte nicht starten',
    host_badge: 'HOST', players_label: 'Spieler',
    lang_name: 'Deutsch',
    chat_label: 'Diskussionsmodus', chat_discuss: 'Vor Ort', chat_online: 'Online Chat',
    chat_open: 'Chat öffnen', chat_placeholder: 'Nachricht...', chat_send: 'Senden', chat_empty: 'Noch keine Nachrichten...',
    chat_phase_open: 'Offene Diskussion — bei Bereitschaft wird abgestimmt.',
    chat_your_turn: 'Du bist dran — schreib EIN Wort!',
    chat_waiting_turn: '{name} ist dran (ein Wort)...',
    chat_one_word_placeholder: 'Nur ein Wort...',
    chat_waiting_turn_placeholder: 'Warte, bis du dran bist...',
    chat_one_word_only: 'Bitte nur ein Wort schreiben.',
    chat_not_your_turn: 'Du bist noch nicht dran.',
    tap_reveal: 'Tippe zum Aufdecken',
    tagline: 'WER BLUFFT?',
    tut_1_title: 'Ein Wort, ein Hochstapler',
    tut_1_text: 'Alle Spieler bekommen dasselbe geheime Wort — bis auf einer. Der Hochstapler weiß nicht, was es ist.',
    tut_2_title: 'Beschreibt & Blufft',
    tut_2_text: 'Beschreibt das Wort vage genug, dass der Hochstapler es nicht errät — aber klar genug, damit eure Mitspieler wissen, dass ihr Bescheid wisst.',
    tut_3_title: 'Findet den Hochstapler',
    tut_3_text: 'Stimmt ab! Wer hat geblufft? Enttarnt den Hochstapler, bevor er davonkommt.',
    tut_4_title: 'Punkte',
    tut_4_text: '<div class="tut-score-grid"><div class="tut-score-section"><div class="tut-score-label">Mitspieler</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Richtig gevoted</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Falsch gevoted</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Hochstapler entwischt</div></div><div class="tut-score-section"><div class="tut-score-label">Hochstapler</div><div class="tut-score-row"><span class="tut-score-plus">+20</span> Entwischt</div><div class="tut-score-row"><span class="tut-score-gold">+25</span> Kein einziger Vote</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Erwischt, Wort erraten</div></div></div>',
    tut_5_title: 'Bereit?',
    tut_5_text: 'Erstellt ein Spiel oder tretet einem bei — viel Spaß!',
    tut_skip: 'Überspringen',
    tut_next: 'Weiter',
    tut_go: 'Los geht\'s!',
    privacy_policy: 'Datenschutz',
    settings_heading: 'EINSTELLUNGEN', settings_version_label: 'App-Version',
    layout_label: 'Darstellung',
    notify_label: 'Hinweise',
    notify_hint: 'Deducto meldet sich, wenn du am Zug bist und das Fenster im Hintergrund liegt.',
    notify_on: 'Hinweise an',
    notify_off: 'Hinweise aus',
    notify_blocked: 'Dein Browser erlaubt keine Hinweise. Der Titel der Seite blinkt weiterhin.',
    notify_unsupported: 'Dieser Browser kennt keine Hinweise. Der Titel der Seite blinkt weiterhin.',
    notify_round_started: 'Die Runde hat begonnen.',
    notify_vote: 'Du bist mit dem Abstimmen dran.',
    notify_guess: 'Du bist aufgeflogen – jetzt das Wort raten.',
    notify_reveal: 'Die Aufloesung ist da.',
    notify_finished: 'Die Partie ist zu Ende.',
    layout_hint: 'Am Rechner kann Deducto die Fläche breiter nutzen.',
    layout_auto: 'Automatisch', layout_mobile: 'Mobil', layout_desktop: 'Desktop',
    offline_banner: 'KEINE VERBINDUNG', network_error: 'Verbindungsfehler',
    rejoin_label: 'ZURÜCK ZU LOBBY',
    spectator_label: 'Beobachter',
    spectator_wait_next_round: 'Du bist ab naechster Runde aktiv',
    spectator_vote_locked: 'Diese Runde ist nur zum Zuschauen',
    points_breakdown: 'Punkte diese Runde',
    points_reason_caught: 'Imposter erwischt: Punkte nach abgegebener Stimme',
    points_reason_escaped: 'Imposter entkommen: Fluchtpunkte',
    points_reason_guess: 'Imposter hat das Wort geraten: +10',
    points_reason_guess_fail: 'Imposter hat das Wort nicht geraten: Imposter +0',
    guess_state_correct: 'RICHTIG', guess_state_wrong: 'FALSCH', score_total: 'Gesamt',
    score_reason_correct_vote: 'Imposter richtig gewählt', score_reason_wrong_vote: 'Falsche Person gewählt',
    score_reason_teammate_escape: 'Imposter ist entkommen', score_reason_escape: 'Als Imposter entkommen',
    score_reason_perfect_escape: 'Perfekte Flucht – keinen Vote erhalten', score_reason_guess_correct: 'Geheimes Wort richtig geraten',
    score_reason_guess_wrong: 'Geheimes Wort nicht geraten', score_reason_no_guess: 'Kein Tipp abgegeben', score_reason_no_points: 'Keine Punkte',
    starts_first: '{name} fängt an',
  },
  en: {
    avatar_select: 'Choose avatar', avatar_change: 'Change avatar', name_placeholder: 'Your name',
    btn_online: 'ONLINE', btn_online_sub: 'Create or join a lobby',
    btn_local: 'LOCAL', btn_local_sub: 'pass the device around',
    btn_wordpacks: 'WORD PACKS',
    wordpacks_heading: 'WORD PACKS',
    wordpacks_subtitle: 'Explore the words and their artwork. Open a pack to see every card.',
    wordpack_active: 'ACTIVE',
    wordpack_categories: 'Categories',
    wordpack_words: 'Terms',
    wordpack_coming: 'MORE PACKS SOON',
    wordpack_future_hint: 'Future packs can bring their own categories, covers, and selection rules.',
    wordpack_empty: 'No Word Packs available yet.',
    lobby_heading: 'LOBBY', btn_create: 'Create game', join_label: 'Enter code',
    btn_join: 'Join', code_label: 'Game code', copied: 'Copied!', qr_scan_hint: 'SCAN TO JOIN',
    rounds_label: 'Rounds', rounds_n: '{n} rounds', time_label: 'Round time', time_infinite: '∞', time_min: '{n} min', categories_label: 'Categories',
    custom_words_label: 'Custom Words', custom_word_placeholder: 'Enter word or paste a list...', custom_words_count: '{n} words',
    btn_start_round: 'Start round',    btn_kill_lobby: 'Close lobby', player_count: '{n} players',
    no_lobbies: 'No lobbies are online right now.', open_games: 'Open games',
    create_lobby_heading: 'CREATE LOBBY', create_access_title: 'LOBBY ACCESS', access_public: 'Open', access_password: 'Password',
    access_public_hint: 'Anyone can join directly.', access_password_hint: 'The lobby stays visible, but joining requires its password.',
    password_placeholder: 'Password (at least 4 characters)', password_optional: 'Password, if required', password_new_placeholder: 'New password', password_hint: 'At least 4 characters.',
    lobby_browser_title: 'ONLINE LOBBIES', lobby_access_label: 'ACCESS', load_more: 'Load more lobbies',
    lobby_status_lobby: 'Waiting in lobby', lobby_status_playing: 'Round in progress', lobby_status_voting: 'Voting', lobby_status_imposter_guess: 'Guessing the word', lobby_status_reveal: 'Results',
    lobby_join_public: 'Join directly', lobby_join_password: 'Join with password', lobby_full: 'Full', lobby_count: '{n} lobbies online',
    lobby_info: '{n}/10 players · {r} rounds', back_to_lobby: 'Back to lobby',
    local_heading: 'LOCAL', add_players: 'Add players (2-6)',
    btn_start_game: 'Start game',
    round_label: 'Round', card_tap: 'Tap to reveal',
    bottom_title: 'SOMEONE\'S LYING',
    bottom_hint: 'Describe your word vaguely — IMPOSTER must bluff.',
    bottom_hint_local: 'Describe the word vaguely — IMPOSTER must bluff!',
    btn_start_vote: 'START VOTING', your_card: 'Your card',
    you_are: 'You are', the_odd_one: 'IMPOSTER', hint_prefix: 'Hint:',
    pass_hint: 'Tap the card to flip', btn_next: 'Next',
    vote_heading: 'VOTE', vote_sub: 'Who is IMPOSTER?',
    btn_vote_ready: 'READY', btn_vote: 'Submit vote', waiting_votes: 'Waiting for all votes...',
    local_vote_hint: 'Tap to vote', btn_vote_short: 'Vote',
    ig_heading: 'CAUGHT!', ig_sub: 'IMPOSTER has been exposed!',
    ig_last_chance: 'Last chance: What was the word?', ig_category: 'Category:',
    ig_placeholder: 'Your guess...', btn_guess: 'Guess',
    ig_waiting: 'IMPOSTER is guessing...', ig_loading: 'Loading result...',
    result_heading: 'RESULT', word_was: 'The word was',
    was_odd_one: '{name} was IMPOSTER',
    badge_caught: 'CAUGHT!', badge_escaped: 'ESCAPED!',
    guess_prefix: 'Guess:', guess_correct: 'Correct! (+10)', guess_wrong: 'Wrong!',
    votes_label: 'Votes', scores_label: 'Scoreboard',
    result_ready: 'READY FOR THE NEXT ROUND', result_ready_waiting: 'Waiting for everyone · {count}/{total} ready',
    btn_next_round: 'Next round', btn_show_final: 'Show final score', btn_continue: 'Continue', loading_next_round: 'Loading next round...',
    final_heading: 'GAME OVER', btn_new_game: 'New game',
    avatar_preview: 'Your GIF avatar', btn_random_avatar: 'Random', btn_save: 'Save',
    giphy_search_placeholder: 'Search memes, GIFs, reactions...', giphy_search_btn: 'Search', giphy_trending: 'Trending GIFs',
    giphy_results_for: 'Results for "{q}"', giphy_empty: 'No GIFs found. Try another meme.',
    giphy_key_missing: 'GIPHY is not configured yet. Set WA_GIPHY_API_KEY on the server or localStorage.wa_giphy_api_key locally.',
    giphy_key_status: 'GIPHY key missing', loading: 'Loading...',
    cat_all_selected: 'All categories', cat_n_selected: '{n} of {total} categories', cat_select_all: 'Select all', cat_deselect_all: 'Deselect all', btn_done: 'Done',
    p_online: '{name} is online', p_offline: '{name} is offline',
    lobby_dissolved: 'Lobby was closed', game_cancelled: 'Game was cancelled',
    error_title: 'Error', error_join: 'Could not join', error_start: 'Could not start',
    host_badge: 'HOST', players_label: 'Players',
    lang_name: 'English',
    chat_label: 'Discussion mode', chat_discuss: 'In person', chat_online: 'Online chat',
    chat_open: 'Open chat', chat_placeholder: 'Message...', chat_send: 'Send', chat_empty: 'No messages yet...',
    chat_phase_open: 'Open discussion — voting starts once everyone is ready.',
    chat_your_turn: 'Your turn — write ONE word!',
    chat_waiting_turn: '{name} is up (one word)...',
    chat_one_word_placeholder: 'Just one word...',
    chat_waiting_turn_placeholder: 'Wait for your turn...',
    chat_one_word_only: 'Please write only one word.',
    chat_not_your_turn: 'It\'s not your turn yet.',
    tap_reveal: 'Tap to reveal',
    tagline: 'WHO BLUFFS?',
    tut_1_title: 'One Word, One Impostor',
    tut_1_text: 'All players receive the same secret word — except one. The impostor doesn\'t know what it is.',
    tut_2_title: 'Describe & Bluff',
    tut_2_text: 'Describe the word vaguely enough so the impostor can\'t guess it — but clearly enough so your teammates know you\'re in on it.',
    tut_3_title: 'Find the Impostor',
    tut_3_text: 'Vote! Who was bluffing? Expose the impostor before they get away.',
    tut_4_title: 'Scoring',
    tut_4_text: '<div class="tut-score-grid"><div class="tut-score-section"><div class="tut-score-label">Players</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Correct vote</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Wrong vote</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Impostor escapes</div></div><div class="tut-score-section"><div class="tut-score-label">Impostor</div><div class="tut-score-row"><span class="tut-score-plus">+20</span> Escapes</div><div class="tut-score-row"><span class="tut-score-gold">+25</span> Zero votes</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Caught, guessed word</div></div></div>',
    tut_5_title: 'Ready?',
    tut_5_text: 'Create a game or join one — have fun!',
    tut_skip: 'Skip',
    tut_next: 'Next',
    tut_go: 'Let\'s go!',
    privacy_policy: 'Privacy Policy',
    settings_heading: 'SETTINGS', settings_version_label: 'App version',
    layout_label: 'Display',
    notify_label: 'Alerts',
    notify_hint: 'Deducto lets you know when it is your turn and the window is in the background.',
    notify_on: 'Alerts on',
    notify_off: 'Alerts off',
    notify_blocked: 'Your browser blocks alerts. The page title will still blink.',
    notify_unsupported: 'This browser has no alerts. The page title will still blink.',
    notify_round_started: 'The round has started.',
    notify_vote: 'It is your turn to vote.',
    notify_guess: 'You were caught – guess the word now.',
    notify_reveal: 'The result is in.',
    notify_finished: 'The game is over.',
    layout_hint: 'On a computer Deducto can use the wider screen.',
    layout_auto: 'Automatic', layout_mobile: 'Mobile', layout_desktop: 'Desktop',
    offline_banner: 'NO CONNECTION', network_error: 'Network error',
    rejoin_label: 'BACK TO LOBBY',
    spectator_label: 'Beobachter',
    spectator_wait_next_round: 'Du bist ab naechster Runde aktiv',
    spectator_vote_locked: 'Diese Runde ist nur zum Zuschauen',
    points_breakdown: 'Punkte diese Runde',
    points_reason_caught: 'Impostor caught: points by submitted vote',
    points_reason_escaped: 'Impostor escaped: escape points',
    points_reason_guess: 'Impostor guessed the word: +10',
    points_reason_guess_fail: 'Imposter hat das Wort nicht geraten: Imposter +0',
    guess_state_correct: 'CORRECT', guess_state_wrong: 'WRONG', score_total: 'Total',
    score_reason_correct_vote: 'Correctly voted for the impostor', score_reason_wrong_vote: 'Voted for the wrong player',
    score_reason_teammate_escape: 'The impostor escaped', score_reason_escape: 'Escaped as the impostor',
    score_reason_perfect_escape: 'Perfect escape – received no votes', score_reason_guess_correct: 'Correctly guessed the secret word',
    score_reason_guess_wrong: 'Did not guess the secret word', score_reason_no_guess: 'No guess submitted', score_reason_no_points: 'No points',
    starts_first: '{name} starts',
  },
  fr: {
    avatar_select: 'Choisir un avatar', avatar_change: 'Changer d\'avatar', name_placeholder: 'Ton nom',
    btn_online: 'ONLINE', btn_online_sub: 'Créer ou rejoindre un salon',
    btn_local: 'LOCAL', btn_local_sub: 'passez l\'appareil',
    btn_wordpacks: 'WORD PACKS',
    wordpacks_heading: 'WORD PACKS',
    wordpacks_subtitle: 'Découvrez les mots et leurs illustrations. Ouvrez un pack pour voir toutes les cartes.',
    wordpack_active: 'ACTIF',
    wordpack_categories: 'Catégories',
    wordpack_words: 'Mots',
    wordpack_coming: 'PLUS DE PACKS BIENTÔT',
    wordpack_future_hint: 'Les futurs packs pourront ajouter leurs propres catégories, couvertures et règles de sélection.',
    wordpack_empty: 'Aucun Word Pack disponible.',
    lobby_heading: 'SALON', btn_create: 'Créer une partie', join_label: 'Entrer le code',
    btn_join: 'Rejoindre', code_label: 'Code de jeu', copied: 'Copié !', qr_scan_hint: 'SCANNER POUR REJOINDRE',
    rounds_label: 'Manches', rounds_n: '{n} manches', time_label: 'Durée du tour', time_infinite: '∞', time_min: '{n} min', categories_label: 'Catégories',
    custom_words_label: 'Mots perso', custom_word_placeholder: 'Mot ou coller une liste...', custom_words_count: '{n} mots',
    btn_start_round: 'Lancer la manche',    btn_kill_lobby: 'Fermer le salon', player_count: '{n} joueurs',
    no_lobbies: 'Aucun salon en ligne pour le moment.', open_games: 'Parties ouvertes',
    create_lobby_heading: 'CRÉER UN SALON', create_access_title: 'ACCÈS AU SALON', access_public: 'Ouvert', access_password: 'Mot de passe',
    access_public_hint: 'Tout le monde peut rejoindre directement.', access_password_hint: 'Le salon reste visible, mais un mot de passe est requis.',
    password_placeholder: 'Mot de passe (4 caractères min.)', password_optional: 'Mot de passe si nécessaire', password_new_placeholder: 'Nouveau mot de passe', password_hint: 'Au moins 4 caractères.',
    lobby_browser_title: 'SALONS EN LIGNE', lobby_access_label: 'ACCÈS', load_more: 'Afficher plus de salons',
    lobby_status_lobby: 'En attente', lobby_status_playing: 'Manche en cours', lobby_status_voting: 'Vote', lobby_status_imposter_guess: 'Mot à deviner', lobby_status_reveal: 'Résultats',
    lobby_join_public: 'Rejoindre directement', lobby_join_password: 'Rejoindre avec mot de passe', lobby_full: 'Complet', lobby_count: '{n} salons en ligne',
    lobby_info: '{n}/10 joueurs · {r} manches', back_to_lobby: 'Retour au salon',
    local_heading: 'LOCAL', add_players: 'Ajouter des joueurs (2-6)',
    btn_start_game: 'Lancer le jeu',
    round_label: 'Manche', card_tap: 'Appuyer pour révéler',
    bottom_title: 'QUELQU\'UN MENT',
    bottom_hint: 'Décrivez votre mot vaguement — IMPOSTER doit bluffer.',
    bottom_hint_local: 'Décrivez le mot vaguement — IMPOSTER doit bluffer !',
    btn_start_vote: 'LANCER LE VOTE', your_card: 'Ta carte',
    you_are: 'Tu es', the_odd_one: 'IMPOSTER', hint_prefix: 'Indice :',
    pass_hint: 'Appuyer sur la carte pour retourner', btn_next: 'Suivant',
    vote_heading: 'VOTE', vote_sub: 'Qui est IMPOSTER ?',
    btn_vote_ready: 'PRÊT', btn_vote: 'Voter', waiting_votes: 'En attente des votes...',
    local_vote_hint: 'Appuyer pour voter', btn_vote_short: 'Voter',
    ig_heading: 'ATTRAPÉ !', ig_sub: 'IMPOSTER a été démasqué !',
    ig_last_chance: 'Dernière chance : Quel était le mot ?', ig_category: 'Catégorie :',
    ig_placeholder: 'Ton essai...', btn_guess: 'Deviner',
    ig_waiting: 'IMPOSTER devine...', ig_loading: 'Chargement du résultat...',
    result_heading: 'RÉSULTAT', word_was: 'Le mot était',
    was_odd_one: '{name} était IMPOSTER',
    badge_caught: 'ATTRAPÉ !', badge_escaped: 'ÉCHAPPÉ !',
    guess_prefix: 'Essai :', guess_correct: 'Correct ! (+10)', guess_wrong: 'Faux !',
    votes_label: 'Votes', scores_label: 'Classement',
    result_ready: 'PRÊT POUR LA PROCHAINE MANCHE', result_ready_waiting: 'En attente · {count}/{total} prêts',
    btn_next_round: 'Manche suivante', btn_show_final: 'Score final', btn_continue: 'Continuer', loading_next_round: 'Chargement de la manche...',
    final_heading: 'FIN DE PARTIE', btn_new_game: 'Nouvelle partie',
    avatar_preview: 'Ton avatar GIF', btn_random_avatar: 'Aléatoire', btn_save: 'Enregistrer',
    giphy_search_placeholder: 'Chercher memes, GIFs, réactions...', giphy_search_btn: 'Chercher', giphy_trending: 'GIFs tendance',
    giphy_results_for: 'Résultats pour "{q}"', giphy_empty: 'Aucun GIF trouvé. Essaie un autre meme.',
    giphy_key_missing: 'GIPHY n’est pas encore configuré. Définis WA_GIPHY_API_KEY sur le serveur ou localStorage.wa_giphy_api_key en local.',
    giphy_key_status: 'Clé GIPHY manquante', loading: 'Chargement...',
    cat_all_selected: 'Toutes les catégories', cat_n_selected: '{n} sur {total} catégories', cat_select_all: 'Tout sélectionner', cat_deselect_all: 'Tout désélectionner', btn_done: 'Terminé',
    p_online: '{name} est en ligne', p_offline: '{name} est hors ligne',
    lobby_dissolved: 'Le salon a été fermé', game_cancelled: 'La partie a été annulée',
    error_title: 'Erreur', error_join: 'Impossible de rejoindre', error_start: 'Impossible de lancer',
    host_badge: 'HÔTE', players_label: 'Joueurs',
    lang_name: 'Français',
    chat_label: 'Mode discussion', chat_discuss: 'En présentiel', chat_online: 'Chat en ligne',
    chat_open: 'Ouvrir le chat', chat_placeholder: 'Message...', chat_send: 'Envoyer', chat_empty: 'Pas encore de messages...',
    chat_phase_open: 'Discussion ouverte — le vote commence quand tout le monde est prêt.',
    chat_your_turn: 'À toi — écris UN seul mot !',
    chat_waiting_turn: '{name} joue (un mot)...',
    chat_one_word_placeholder: 'Un seul mot...',
    chat_waiting_turn_placeholder: 'Attends ton tour...',
    chat_one_word_only: 'Merci de n\'écrire qu\'un seul mot.',
    chat_not_your_turn: 'Ce n\'est pas encore ton tour.',
    tap_reveal: 'Appuyer pour révéler',
    tagline: 'QUI BLUFFE ?',
    tut_1_title: 'Un mot, un imposteur',
    tut_1_text: 'Tous les joueurs reçoivent le même mot secret — sauf un. L\'imposteur ne sait pas de quoi il s\'agit.',
    tut_2_title: 'Décrivez & Bluffez',
    tut_2_text: 'Décrivez le mot assez vaguement pour que l\'imposteur ne le devine pas — mais assez clairement pour prouver à vos coéquipiers que vous le connaissez.',
    tut_3_title: 'Trouvez l\'imposteur',
    tut_3_text: 'Votez ! Qui a bluffé ? Démasquez l\'imposteur avant qu\'il ne s\'échappe.',
    tut_4_title: 'Points',
    tut_4_text: '<div class="tut-score-grid"><div class="tut-score-section"><div class="tut-score-label">Joueurs</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Vote correct</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Vote faux</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Imposteur s\'échappe</div></div><div class="tut-score-section"><div class="tut-score-label">Imposteur</div><div class="tut-score-row"><span class="tut-score-plus">+20</span> S\'échappe</div><div class="tut-score-row"><span class="tut-score-gold">+25</span> Aucun vote</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Attrapé, mot deviné</div></div></div>',
    tut_5_title: 'Prêt ?',
    tut_5_text: 'Créez une partie ou rejoignez-en une — amusez-vous !',
    tut_skip: 'Passer',
    tut_next: 'Suivant',
    tut_go: 'C\'est parti !',
    privacy_policy: 'Politique de confidentialité',
    settings_heading: 'PARAMÈTRES', settings_version_label: 'Version de l\'app',
    layout_label: 'Affichage',
    notify_label: 'Alertes',
    notify_hint: 'Deducto te prévient quand c’est ton tour et que la fenêtre est en arrière-plan.',
    notify_on: 'Alertes activées',
    notify_off: 'Alertes désactivées',
    notify_blocked: 'Ton navigateur bloque les alertes. Le titre de la page clignotera quand même.',
    notify_unsupported: 'Ce navigateur ne gère pas les alertes. Le titre de la page clignotera quand même.',
    notify_round_started: 'La manche a commencé.',
    notify_vote: 'C’est à toi de voter.',
    notify_guess: 'Tu es démasqué – devine le mot.',
    notify_reveal: 'Le résultat est là.',
    notify_finished: 'La partie est terminée.',
    layout_hint: 'Sur ordinateur, Deducto peut utiliser tout l’écran.',
    layout_auto: 'Automatique', layout_mobile: 'Mobile', layout_desktop: 'Ordinateur',
    offline_banner: 'PAS DE CONNEXION', network_error: 'Erreur réseau',
    rejoin_label: 'RETOUR AU LOBBY',
    spectator_label: 'Beobachter',
    spectator_wait_next_round: 'Du bist ab naechster Runde aktiv',
    spectator_vote_locked: 'Diese Runde ist nur zum Zuschauen',
    points_breakdown: 'Punkte diese Runde',
    points_reason_caught: 'Imposteur attrapé : points selon chaque vote',
    points_reason_escaped: 'Imposteur échappé : points de fuite',
    points_reason_guess: 'Mot deviné par l’imposteur : +10',
    points_reason_guess_fail: 'Imposter hat das Wort nicht geraten: Imposter +0',
    guess_state_correct: 'CORRECT', guess_state_wrong: 'FAUX', score_total: 'Total',
    score_reason_correct_vote: 'Bon vote contre l’imposteur', score_reason_wrong_vote: 'Mauvais joueur choisi',
    score_reason_teammate_escape: 'L’imposteur s’est échappé', score_reason_escape: 'Échappé comme imposteur',
    score_reason_perfect_escape: 'Fuite parfaite – aucun vote reçu', score_reason_guess_correct: 'Mot secret correctement deviné',
    score_reason_guess_wrong: 'Mot secret non deviné', score_reason_no_guess: 'Aucun essai', score_reason_no_points: 'Aucun point',
    starts_first: '{name} commence',
  },
  it: {
    avatar_select: 'Scegli avatar', avatar_change: 'Cambia avatar', name_placeholder: 'Il tuo nome',
    btn_online: 'ONLINE', btn_online_sub: 'Crea o entra in una lobby',
    btn_local: 'LOCALE', btn_local_sub: 'passatevi il dispositivo',
    btn_wordpacks: 'WORD PACKS',
    wordpacks_heading: 'WORD PACKS',
    wordpacks_subtitle: 'Scopri le parole e le loro illustrazioni. Apri un pack per vedere tutte le carte.',
    wordpack_active: 'ATTIVO',
    wordpack_categories: 'Categorie',
    wordpack_words: 'Parole',
    wordpack_coming: 'ALTRI PACK PRESTO',
    wordpack_future_hint: 'I prossimi pack potranno avere categorie, cover e regole di selezione proprie.',
    wordpack_empty: 'Nessun Word Pack disponibile.',
    lobby_heading: 'LOBBY', btn_create: 'Crea partita', join_label: 'Inserisci codice',
    btn_join: 'Entra', code_label: 'Codice partita', copied: 'Copiato!', qr_scan_hint: 'SCANSIONA PER UNIRTI',
    rounds_label: 'Round', rounds_n: '{n} round', time_label: 'Tempo del turno', time_infinite: '∞', time_min: '{n} min', categories_label: 'Categorie',
    custom_words_label: 'Parole personali', custom_word_placeholder: 'Parola o incolla una lista...', custom_words_count: '{n} parole',
    btn_start_round: 'Inizia round',    btn_kill_lobby: 'Chiudi lobby', player_count: '{n} giocatori',
    no_lobbies: 'Nessuna lobby online al momento.', open_games: 'Partite aperte',
    create_lobby_heading: 'CREA LOBBY', create_access_title: 'ACCESSO ALLA LOBBY', access_public: 'Aperta', access_password: 'Password',
    access_public_hint: 'Chiunque può entrare direttamente.', access_password_hint: 'La lobby resta visibile, ma serve la password per entrare.',
    password_placeholder: 'Password (almeno 4 caratteri)', password_optional: 'Password, se richiesta', password_new_placeholder: 'Nuova password', password_hint: 'Almeno 4 caratteri.',
    lobby_browser_title: 'LOBBY ONLINE', lobby_access_label: 'ACCESSO', load_more: 'Carica altre lobby',
    lobby_status_lobby: 'In attesa', lobby_status_playing: 'Round in corso', lobby_status_voting: 'Votazione', lobby_status_imposter_guess: 'Parola da indovinare', lobby_status_reveal: 'Risultati',
    lobby_join_public: 'Entra subito', lobby_join_password: 'Entra con password', lobby_full: 'Piena', lobby_count: '{n} lobby online',
    lobby_info: '{n}/10 giocatori · {r} round', back_to_lobby: 'Torna alla lobby',
    local_heading: 'LOCALE', add_players: 'Aggiungi giocatori (2-6)',
    btn_start_game: 'Inizia partita',
    round_label: 'Round', card_tap: 'Tocca per rivelare',
    bottom_title: 'QUALCUNO MENTE',
    bottom_hint: 'Descrivete la parola vagamente — IMPOSTER deve bluffare.',
    bottom_hint_local: 'Descrivete la parola vagamente — IMPOSTER deve bluffare!',
    btn_start_vote: 'INIZIA VOTAZIONE', your_card: 'La tua carta',
    you_are: 'Sei', the_odd_one: 'IMPOSTER', hint_prefix: 'Indizio:',
    pass_hint: 'Tocca la carta per girarla', btn_next: 'Avanti',
    vote_heading: 'VOTAZIONE', vote_sub: 'Chi è IMPOSTER?',
    btn_vote_ready: 'PRONTO', btn_vote: 'Vota', waiting_votes: 'In attesa di tutti i voti...',
    local_vote_hint: 'Tocca per votare', btn_vote_short: 'Vota',
    ig_heading: 'BECCATO!', ig_sub: 'IMPOSTER è stato smascherato!',
    ig_last_chance: 'Ultima possibilità: Qual era la parola?', ig_category: 'Categoria:',
    ig_placeholder: 'Il tuo tentativo...', btn_guess: 'Indovina',
    ig_waiting: 'IMPOSTER sta indovinando...', ig_loading: 'Caricamento risultato...',
    result_heading: 'RISULTATO', word_was: 'La parola era',
    was_odd_one: '{name} era IMPOSTER',
    badge_caught: 'BECCATO!', badge_escaped: 'SCAPPATO!',
    guess_prefix: 'Tentativo:', guess_correct: 'Corretto! (+10)', guess_wrong: 'Sbagliato!',
    votes_label: 'Voti', scores_label: 'Classifica',
    result_ready: 'PRONTO PER IL PROSSIMO ROUND', result_ready_waiting: 'In attesa · {count}/{total} pronti',
    btn_next_round: 'Prossimo round', btn_show_final: 'Punteggio finale', btn_continue: 'Continua', loading_next_round: 'Caricamento prossimo round...',
    final_heading: 'FINE PARTITA', btn_new_game: 'Nuova partita',
    avatar_preview: 'Il tuo avatar GIF', btn_random_avatar: 'Casuale', btn_save: 'Salva',
    giphy_search_placeholder: 'Cerca meme, GIF, reaction...', giphy_search_btn: 'Cerca', giphy_trending: 'GIF di tendenza',
    giphy_results_for: 'Risultati per "{q}"', giphy_empty: 'Nessuna GIF trovata. Prova un altro meme.',
    giphy_key_missing: 'GIPHY non è ancora configurato. Imposta WA_GIPHY_API_KEY sul server o localStorage.wa_giphy_api_key in locale.',
    giphy_key_status: 'Chiave GIPHY mancante', loading: 'Caricamento...',
    cat_all_selected: 'Tutte le categorie', cat_n_selected: '{n} di {total} categorie', cat_select_all: 'Seleziona tutto', cat_deselect_all: 'Deseleziona tutto', btn_done: 'Fatto',
    p_online: '{name} è online', p_offline: '{name} è offline',
    lobby_dissolved: 'La lobby è stata chiusa', game_cancelled: 'La partita è stata annullata',
    error_title: 'Errore', error_join: 'Impossibile entrare', error_start: 'Impossibile avviare',
    host_badge: 'HOST', players_label: 'Giocatori',
    lang_name: 'Italiano',
    chat_label: 'Modalità chat', chat_discuss: 'Di persona', chat_online: 'Chat online',
    chat_open: 'Apri chat', chat_placeholder: 'Messaggio...', chat_send: 'Invia', chat_empty: 'Ancora nessun messaggio...',
    chat_phase_open: 'Discussione aperta — si vota quando tutti sono pronti.',
    chat_your_turn: 'Tocca a te — scrivi UNA parola!',
    chat_waiting_turn: 'Tocca a {name} (una parola)...',
    chat_one_word_placeholder: 'Solo una parola...',
    chat_waiting_turn_placeholder: 'Aspetta il tuo turno...',
    chat_one_word_only: 'Scrivi solo una parola, per favore.',
    chat_not_your_turn: 'Non tocca ancora a te.',
    tap_reveal: 'Tocca per rivelare',
    tagline: 'CHI BLUFFA?',
    tut_1_title: 'Una parola, un impostore',
    tut_1_text: 'Tutti i giocatori ricevono la stessa parola segreta — tranne uno. L\'impostore non sa qual è.',
    tut_2_title: 'Descrivi & Bluffa',
    tut_2_text: 'Descrivi la parola in modo abbastanza vago da non farla indovinare all\'impostore — ma abbastanza chiaro da dimostrare ai compagni che la conosci.',
    tut_3_title: 'Trova l\'impostore',
    tut_3_text: 'Votate! Chi stava bluffando? Smascheratelo prima che scappi.',
    tut_4_title: 'Punteggio',
    tut_4_text: '<div class="tut-score-grid"><div class="tut-score-section"><div class="tut-score-label">Giocatori</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Voto corretto</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Voto sbagliato</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Impostore scappa</div></div><div class="tut-score-section"><div class="tut-score-label">Impostore</div><div class="tut-score-row"><span class="tut-score-plus">+20</span> Scappa</div><div class="tut-score-row"><span class="tut-score-gold">+25</span> Zero voti</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Beccato, parola indovinata</div></div></div>',
    tut_5_title: 'Pronti?',
    tut_5_text: 'Create una partita o unitevi — buon divertimento!',
    tut_skip: 'Salta',
    tut_next: 'Avanti',
    tut_go: 'Via!',
    privacy_policy: 'Privacy',
    settings_heading: 'IMPOSTAZIONI', settings_version_label: 'Versione app',
    layout_label: 'Visualizzazione',
    notify_label: 'Avvisi',
    notify_hint: 'Deducto ti avverte quando è il tuo turno e la finestra è in secondo piano.',
    notify_on: 'Avvisi attivi',
    notify_off: 'Avvisi spenti',
    notify_blocked: 'Il browser blocca gli avvisi. Il titolo della pagina lampeggia comunque.',
    notify_unsupported: 'Questo browser non ha avvisi. Il titolo della pagina lampeggia comunque.',
    notify_round_started: 'Il turno è iniziato.',
    notify_vote: 'È il tuo turno di votare.',
    notify_guess: 'Sei stato scoperto – indovina la parola.',
    notify_reveal: 'Il risultato è pronto.',
    notify_finished: 'La partita è finita.',
    layout_hint: 'Sul computer Deducto può sfruttare tutto lo schermo.',
    layout_auto: 'Automatica', layout_mobile: 'Mobile', layout_desktop: 'Desktop',
    offline_banner: 'NESSUNA CONNESSIONE', network_error: 'Errore di rete',
    rejoin_label: 'TORNA ALLA LOBBY',
    spectator_label: 'Beobachter',
    spectator_wait_next_round: 'Du bist ab naechster Runde aktiv',
    spectator_vote_locked: 'Diese Runde ist nur zum Zuschauen',
    points_breakdown: 'Punkte diese Runde',
    points_reason_caught: 'Impostore scoperto: punti in base al voto',
    points_reason_escaped: 'Impostore fuggito: punti fuga',
    points_reason_guess: 'Parola indovinata dall’impostore: +10',
    points_reason_guess_fail: 'Imposter hat das Wort nicht geraten: Imposter +0',
    guess_state_correct: 'CORRETTO', guess_state_wrong: 'SBAGLIATO', score_total: 'Totale',
    score_reason_correct_vote: 'Impostore votato correttamente', score_reason_wrong_vote: 'Giocatore sbagliato votato',
    score_reason_teammate_escape: 'L’impostore è scappato', score_reason_escape: 'Fuga come impostore',
    score_reason_perfect_escape: 'Fuga perfetta – nessun voto ricevuto', score_reason_guess_correct: 'Parola segreta indovinata',
    score_reason_guess_wrong: 'Parola segreta non indovinata', score_reason_no_guess: 'Nessun tentativo', score_reason_no_points: 'Nessun punto',
    starts_first: '{name} inizia',
  },
  es: {
    avatar_select: 'Elegir avatar', avatar_change: 'Cambiar avatar', name_placeholder: 'Tu nombre',
    btn_online: 'ONLINE', btn_online_sub: 'Crear o unirse a una sala',
    btn_local: 'LOCAL', btn_local_sub: 'pasad el dispositivo',
    btn_wordpacks: 'WORD PACKS',
    wordpacks_heading: 'WORD PACKS',
    wordpacks_subtitle: 'Descubre las palabras y sus ilustraciones. Abre un pack para ver todas las cartas.',
    wordpack_active: 'ACTIVO',
    wordpack_categories: 'Categorías',
    wordpack_words: 'Palabras',
    wordpack_coming: 'MÁS PACKS PRONTO',
    wordpack_future_hint: 'Los futuros packs podrán traer categorías, portadas y reglas de selección propias.',
    wordpack_empty: 'Todavía no hay Word Packs disponibles.',
    lobby_heading: 'SALA', btn_create: 'Crear partida', join_label: 'Introducir código',
    btn_join: 'Unirse', code_label: 'Código de juego', copied: '¡Copiado!', qr_scan_hint: 'ESCANEAR PARA UNIRSE',
    rounds_label: 'Rondas', rounds_n: '{n} rondas', time_label: 'Tiempo de ronda', time_infinite: '∞', time_min: '{n} min', categories_label: 'Categorías',
    custom_words_label: 'Palabras propias', custom_word_placeholder: 'Palabra o pegar una lista...', custom_words_count: '{n} palabras',
    btn_start_round: 'Iniciar ronda',    btn_kill_lobby: 'Cerrar sala', player_count: '{n} jugadores',
    no_lobbies: 'Ahora mismo no hay salas online.', open_games: 'Partidas abiertas',
    create_lobby_heading: 'CREAR SALA', create_access_title: 'ACCESO A LA SALA', access_public: 'Abierta', access_password: 'Contraseña',
    access_public_hint: 'Cualquiera puede unirse directamente.', access_password_hint: 'La sala sigue visible, pero se necesita la contraseña para entrar.',
    password_placeholder: 'Contraseña (mínimo 4 caracteres)', password_optional: 'Contraseña, si es necesaria', password_new_placeholder: 'Nueva contraseña', password_hint: 'Mínimo 4 caracteres.',
    lobby_browser_title: 'SALAS ONLINE', lobby_access_label: 'ACCESO', load_more: 'Cargar más salas',
    lobby_status_lobby: 'Esperando', lobby_status_playing: 'Ronda en curso', lobby_status_voting: 'Votación', lobby_status_imposter_guess: 'Adivinando la palabra', lobby_status_reveal: 'Resultados',
    lobby_join_public: 'Unirse directamente', lobby_join_password: 'Unirse con contraseña', lobby_full: 'Llena', lobby_count: '{n} salas online',
    lobby_info: '{n}/10 jugadores · {r} rondas', back_to_lobby: 'Volver a la sala',
    local_heading: 'LOCAL', add_players: 'Añadir jugadores (2-6)',
    btn_start_game: 'Iniciar juego',
    round_label: 'Ronda', card_tap: 'Toca para revelar',
    bottom_title: 'ALGUIEN MIENTE',
    bottom_hint: 'Describid vuestra palabra vagamente — IMPOSTER debe farolear.',
    bottom_hint_local: '¡Describid la palabra vagamente — IMPOSTER debe farolear!',
    btn_start_vote: 'INICIAR VOTACIÓN', your_card: 'Tu carta',
    you_are: 'Eres', the_odd_one: 'IMPOSTER', hint_prefix: 'Pista:',
    pass_hint: 'Toca la carta para voltearla', btn_next: 'Siguiente',
    vote_heading: 'VOTACIÓN', vote_sub: '¿Quién es IMPOSTER?',
    btn_vote_ready: 'LISTO', btn_vote: 'Votar', waiting_votes: 'Esperando todos los votos...',
    local_vote_hint: 'Toca para votar', btn_vote_short: 'Votar',
    ig_heading: '¡ATRAPADO!', ig_sub: '¡IMPOSTER ha sido descubierto!',
    ig_last_chance: 'Última oportunidad: ¿Cuál era la palabra?', ig_category: 'Categoría:',
    ig_placeholder: 'Tu intento...', btn_guess: 'Adivinar',
    ig_waiting: 'IMPOSTER está adivinando...', ig_loading: 'Cargando resultado...',
    result_heading: 'RESULTADO', word_was: 'La palabra era',
    was_odd_one: '{name} era IMPOSTER',
    badge_caught: '¡ATRAPADO!', badge_escaped: '¡ESCAPADO!',
    guess_prefix: 'Intento:', guess_correct: '¡Correcto! (+10)', guess_wrong: '¡Incorrecto!',
    votes_label: 'Votos', scores_label: 'Puntuación',
    result_ready: 'LISTO PARA LA SIGUIENTE RONDA', result_ready_waiting: 'Esperando · {count}/{total} listos',
    btn_next_round: 'Siguiente ronda', btn_show_final: 'Puntuación final', btn_continue: 'Continuar', loading_next_round: 'Cargando siguiente ronda...',
    final_heading: 'FIN DEL JUEGO', btn_new_game: 'Nueva partida',
    avatar_preview: 'Tu avatar GIF', btn_random_avatar: 'Aleatorio', btn_save: 'Guardar',
    giphy_search_placeholder: 'Buscar memes, GIFs, reacciones...', giphy_search_btn: 'Buscar', giphy_trending: 'GIFs en tendencia',
    giphy_results_for: 'Resultados para "{q}"', giphy_empty: 'No se encontraron GIFs. Prueba otro meme.',
    giphy_key_missing: 'GIPHY aún no está configurado. Define WA_GIPHY_API_KEY en el servidor o localStorage.wa_giphy_api_key en local.',
    giphy_key_status: 'Falta clave GIPHY', loading: 'Cargando...',
    cat_all_selected: 'Todas las categorías', cat_n_selected: '{n} de {total} categorías', cat_select_all: 'Seleccionar todo', cat_deselect_all: 'Deseleccionar todo', btn_done: 'Listo',
    p_online: '{name} está en línea', p_offline: '{name} está desconectado',
    lobby_dissolved: 'La sala fue cerrada', game_cancelled: 'La partida fue cancelada',
    error_title: 'Error', error_join: 'No se pudo unir', error_start: 'No se pudo iniciar',
    host_badge: 'ANFITRIÓN', players_label: 'Jugadores',
    lang_name: 'Español',
    chat_label: 'Modo debate', chat_discuss: 'En persona', chat_online: 'Chat online',
    chat_open: 'Abrir chat', chat_placeholder: 'Mensaje...', chat_send: 'Enviar', chat_empty: 'Todavía sin mensajes...',
    chat_phase_open: 'Discusión abierta — se vota cuando todos estén listos.',
    chat_your_turn: 'Tu turno — ¡escribe UNA palabra!',
    chat_waiting_turn: 'Le toca a {name} (una palabra)...',
    chat_one_word_placeholder: 'Solo una palabra...',
    chat_waiting_turn_placeholder: 'Espera tu turno...',
    chat_one_word_only: 'Por favor escribe solo una palabra.',
    chat_not_your_turn: 'Todavía no es tu turno.',
    tap_reveal: 'Toca para revelar',
    tagline: '¿QUIÉN MIENTE?',
    tut_1_title: 'Una palabra, un impostor',
    tut_1_text: 'Todos los jugadores reciben la misma palabra secreta — excepto uno. El impostor no sabe cuál es.',
    tut_2_title: 'Describid & Farolear',
    tut_2_text: 'Describid la palabra de forma lo bastante vaga para que el impostor no la adivine — pero lo bastante clara para que vuestros compañeros sepan que la conocéis.',
    tut_3_title: 'Encontrad al impostor',
    tut_3_text: '¡Votad! ¿Quién estaba faroleando? Descubrid al impostor antes de que escape.',
    tut_4_title: 'Puntuación',
    tut_4_text: '<div class="tut-score-grid"><div class="tut-score-section"><div class="tut-score-label">Jugadores</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Voto correcto</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Voto incorrecto</div><div class="tut-score-row"><span class="tut-score-minus">-5</span> Impostor escapa</div></div><div class="tut-score-section"><div class="tut-score-label">Impostor</div><div class="tut-score-row"><span class="tut-score-plus">+20</span> Escapa</div><div class="tut-score-row"><span class="tut-score-gold">+25</span> Cero votos</div><div class="tut-score-row"><span class="tut-score-plus">+10</span> Atrapado, adivina palabra</div></div></div>',
    tut_5_title: '¿Listos?',
    tut_5_text: '¡Cread una partida o uniros a una — a pasarlo bien!',
    tut_skip: 'Saltar',
    tut_next: 'Siguiente',
    tut_go: '¡Vamos!',
    privacy_policy: 'Privacidad',
    settings_heading: 'AJUSTES', settings_version_label: 'Versión de la app',
    layout_label: 'Visualización',
    notify_label: 'Avisos',
    notify_hint: 'Deducto te avisa cuando es tu turno y la ventana está en segundo plano.',
    notify_on: 'Avisos activados',
    notify_off: 'Avisos desactivados',
    notify_blocked: 'Tu navegador bloquea los avisos. El título de la página seguirá parpadeando.',
    notify_unsupported: 'Este navegador no tiene avisos. El título de la página seguirá parpadeando.',
    notify_round_started: 'La ronda ha empezado.',
    notify_vote: 'Es tu turno de votar.',
    notify_guess: 'Te han descubierto – adivina la palabra.',
    notify_reveal: 'El resultado ya está.',
    notify_finished: 'La partida ha terminado.',
    layout_hint: 'En el ordenador Deducto puede usar toda la pantalla.',
    layout_auto: 'Automático', layout_mobile: 'Móvil', layout_desktop: 'Escritorio',
    offline_banner: 'SIN CONEXIÓN', network_error: 'Error de red',
    rejoin_label: 'VOLVER AL LOBBY',
    spectator_label: 'Beobachter',
    spectator_wait_next_round: 'Du bist ab naechster Runde aktiv',
    spectator_vote_locked: 'Diese Runde ist nur zum Zuschauen',
    points_breakdown: 'Punkte diese Runde',
    points_reason_caught: 'Impostor atrapado: puntos según cada voto',
    points_reason_escaped: 'Impostor escapado: puntos de fuga',
    points_reason_guess: 'El impostor adivinó la palabra: +10',
    points_reason_guess_fail: 'Imposter hat das Wort nicht geraten: Imposter +0',
    guess_state_correct: 'CORRECTO', guess_state_wrong: 'INCORRECTO', score_total: 'Total',
    score_reason_correct_vote: 'Impostor votado correctamente', score_reason_wrong_vote: 'Jugador equivocado votado',
    score_reason_teammate_escape: 'El impostor escapó', score_reason_escape: 'Escapó como impostor',
    score_reason_perfect_escape: 'Escape perfecto – no recibió votos', score_reason_guess_correct: 'Palabra secreta adivinada',
    score_reason_guess_wrong: 'No adivinó la palabra secreta', score_reason_no_guess: 'Sin intento', score_reason_no_points: 'Sin puntos',
    starts_first: '{name} empieza',
  },
};

export function t(key: string, vars?: Record<string, string | number>): string {
  let s = I18N[window._lang]?.[key] || I18N.de[key] || key;
  if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, String(v)); });
  return s;
}

export function setLang(lang: string): void {
  window._lang = lang;
  localStorage.setItem('oo_lang', lang);
  location.reload();
}

declare global {
  interface Window {
    I18N: typeof I18N;
    _lang: string;
    t: typeof t;
    setLang: typeof setLang;
  }
}

// Exposed on window: the legacy inline script (index.html) reads `I18N`/`_lang`
// as bare globals and calls `t(...)`/`setLang(...)` directly (incl. from
// `onclick="setLang('en')"`).
window.I18N = I18N;
let initialLang = localStorage.getItem('oo_lang') || (navigator.language || 'de').slice(0, 2);
if (!I18N[initialLang]) initialLang = 'de';
window._lang = initialLang;
window.t = t;
window.setLang = setLang;
